import type { IServerSideSelectionState } from 'ag-grid-community';

export class GridSelectionState {
    /**
     * If the select all checkbox is checked or not
     */
    public selectAll: boolean = false;

    /**
     * The ids of the selected rows
     * Note. If the selectAll is checked, this will contain the ids of the ones that are NOT selected. If it is empty then it means all rows are selected
     * Note2! If the selectAll is not checked, this will contain the ids of the selected rows
     */
    public toggledNodes: string[] = [];

    /**
     * Constructor for the GridSelectionState
     * @param selectAll
     * @param selectedIds
     */
    public constructor(state: IServerSideSelectionState) {
        this.selectAll = state?.selectAll;
        this.toggledNodes = state?.toggledNodes;
    }

    /**
     * Gets the current selection state
     * @returns
     */
    public toAGGridState(): IServerSideSelectionState {
        return {
            selectAll: this.selectAll,
            toggledNodes: this.toggledNodes,
        };
    }
}
